<template>
    <div class="flex items-center justify-center w-full">
        <button class=" left-0 transform -translate-y-1/2 bg-white text-hgray focus:outline-none p-2 rounded-full" @click.passive="prevSlide"><svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10.707 3.293a1 1 0 011.414 1.414L7.414 10l4.707 4.707a1 1 0 01-1.414 1.414l-5-5a1 1 0 010-1.414l5-5a1 1 0 010 1.414z" clip-rule="evenodd"></path></svg></button>
        <div class="relative w-full overflow-hidden">
            <div class="flex w-full max-w-4xl lg:max-w-[1200px] transition-transform duration-700 ease-in-out" :style="{ transform: `translateX(-${currentIndex * 100 / imagesPerView}%)` }">
                <div v-for="(item, index) in items" :key="index" class="flex-shrink-0 w-full lg:w-1/3 md:w-1/2 px-2">
                    <img :src="item" @click.stop="openLightBox(item, altTexts[index])" :alt="altTexts[index]" class="w-full h-64 object-cover lg:cursor-zoom-in rounded-none shadow-lg"/>
                </div>
            </div>
        </div>
        <button  class=" right-0 transform -translate-y-1/2 bg-white text-hgray focus:outline-none p-2 rounded-full" @click.passive="nextSlide"><svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M9.293 16.707a1 1 0 01-1.414-1.414L12.586 10 7.879 5.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg></button>
        
        <div v-if="lightboxOpen" class="lightbox hidden lg:block z-[51]">
            <img :src="image" :alt="alt" class="lg:w-[50%] md:w-[60%] w-[75%]">
            <button @click.stop="closeLightbox" class="absolute top-[5%] right-[20%] focus:outline-none rounded-none px-3 text-[18px] font-bold bg-transparent hover:text-hwine text-white">X</button>
        </div>
    </div> 
</template>

<script>
export default {
data() {
    return {
        currentIndex: 0,
        lightboxOpen: false,
        image: '',
        alt: '',
        // 1. Nuevas propiedades para guardar los valores del navegador
        imagesPerView: 1, // Valor por defecto para el servidor
        maxCarouselIndex: 14, // Valor por defecto para el servidor
        items: [
            '/pagesImages/responsabilidad-social-grupo-jovenes-recolectando-basura.webp',
            '/pagesImages/alumna-humanitas-programa-interaccion-adultos-mayores.webp',
            '/pagesImages/responsabilidad-social-joven-con-carretilla.webp',
            '/pagesImages/alumna-humanitas-programa-sustentabilidad.webp',
            '/pagesImages/responsabilidad-social-joven-recolectando-basura-playa.webp',
            '/pagesImages/cuidado-medio-ambiente-humanitas-vive.webp',
            '/pagesImages/responsabilidad-social-joven-limpia-lago.webp',
            '/pagesImages/alumna-humanitas-actividad-cuidado-animales.webp',
            '/pagesImages/responsabilidad-social-joven-limpiando-lago.webp',
            '/pagesImages/actividad-adultos-mayores-humanitas-vive.webp',
            '/pagesImages/responsabilidad-social-tres-jovenes-limpiando.webp',
            '/pagesImages/actividad-ninos-programa-humanitas-vive.webp',
            '/pagesImages/responsabilidad-social-joven-en-vivero.webp',
            '/pagesImages/alumnos-humanitas-programa-responsabilidad-social-ninos.webp',
        ],
        altTexts: [
            'Grupo de jóvenes que son parte del programa de responsabilidad social Humanitas',
            'Alumna de Humanitas en programa de interacción con adultos mayores',
            'Estudiante y miembro del programa de responsabilidad social Humanitas',
            'Alumna de Humanitas en programa de sustentabilidad',
            'Estudiante y miembro del programa de responsabilidad social Humanitas',
            'Cuidado del medio ambiente Humanitas Vive',
            'Joven limpia lago y forma parte del programa de responsabilidad social Humanitas',
            'Alumna Humanitas en actividad de cuidado de animales',
            'Joven quien es parte del programa de responsabilidad social Humanitas',
            'Actividad con adultos mayores en Humanitas Vive',
            'Tres jóvenes limpiando, parte del programa de responsabilidad social Humanitas',
            'Actividad con niños del programa Humanitas Vive',
            'Joven en vivero, quien es parte del programa de responsabilidad social Humanitas',
            'Alumnos Humanitas en programa de responsabilidad social con niños',
        ],
    };
},
methods: {
        // 2. Nuevo método que SÍ puede usar `window` porque solo lo llamaremos en el cliente
        updateViewParameters() {
            const width = window.innerWidth;
            if (width >= 1024) {
                // @ts-ignore
                this.imagesPerView = 3;
                // @ts-ignore
                this.maxCarouselIndex = this.items.length - this.imagesPerView; //  14 - 3 = 11
            } else if (width >= 768) {
                // @ts-ignore
                this.imagesPerView = 2;
                // @ts-ignore
                this.maxCarouselIndex = this.items.length - this.imagesPerView; // 14 - 2 = 12
            } else {
                // @ts-ignore
                this.imagesPerView = 1;
                // @ts-ignore
                this.maxCarouselIndex = this.items.length - this.imagesPerView; // 14 - 1 = 13
            }
        },
        /**
     * @param {string} image
     * @param {string} alt
     */
        /**
     * @param {string} image
     * @param {string} alt
     */
        openLightBox(image, alt) {
            if (window.innerWidth < 1024) return; // No abrir en móvil
            // @ts-ignore
            this.image = image;
            // @ts-ignore
            this.alt = alt;
            // @ts-ignore
            this.lightboxOpen = true;
        },
        closeLightbox() {
            // @ts-ignore
            this.image = '';
            // @ts-ignore
            this.lightboxOpen = false;
        },
        nextSlide() {
            // 4. Usamos la nueva propiedad calculada
            // @ts-ignore
            if (this.currentIndex < this.maxCarouselIndex) {
                // @ts-ignore
                this.currentIndex++;
            }
        },
        prevSlide() {
            // @ts-ignore
            if (this.currentIndex > 0) {
                // @ts-ignore
                this.currentIndex--;
            }
        },
        /**
         * @param {{ key: string; }} event
         */
        /**
         * @param {{ key: string; }} event
         */
        closeLightboxKey(event) {
            if (event.key === 'Escape') {
                this.closeLightbox();
            }
        }
    },
    mounted() {
        // 3. Llamamos al método de actualización en el cliente
        this.updateViewParameters();
        window.addEventListener('resize', this.updateViewParameters);
        window.addEventListener('keydown', this.closeLightboxKey);
    },
    beforeUnmount() {
        // Limpiamos los listeners
        window.removeEventListener('resize', this.updateViewParameters);
        window.removeEventListener('keydown', this.closeLightboxKey);
    },
};
</script>

<style scoped>
	.lightbox {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.8);
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.lightbox iframe {
		width: 55%;
		height: 55%;
	}

	.close-button {
		border: none;
		cursor: pointer;
		font-size: 16px;
		position: absolute;
		right: 20%;
	}

	.lightbox-trigger {
		position: relative;
		cursor: pointer;
		
	}
</style>